export default __webpack_public_path__ + "5edc5bf4d40a2e5290c3c27e299db11f.gif";